import React from "react";
import { Link } from "react-router-dom";
import style from "./breadcrumb.module.scss";

export const Breadcrumb = ({ breadcrumbs }) => {
  if (!breadcrumbs?.show) return null;
  return (
    <div>
      <nav className={style.breadcrumb}>
        {breadcrumbs?.items?.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs?.items?.length - 1;
          const isClickable = !isLast && !breadcrumb.isVirtual;
          return (
            <span key={index}>
              {isClickable ? <Link to={breadcrumb.path}>{breadcrumb.label}</Link> : <span className="active">{breadcrumb.label}</span>}
            </span>
          );
        })}
      </nav>
    </div>
  );
};
